import script from "./SetPasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SetPasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./SetPasswordForm.vue?vue&type=style&index=0&id=7f58af72&lang=scss"

const __exports__ = script;

export default __exports__